/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

export const isDebug: boolean =process.env.NEXT_PUBLIC_DEBUG_MODE === "true";
export const url: string =process.env.NEXT_PUBLIC_URL || '';
export const wedsnapURL: string =process.env.NEXT_PUBLIC_WEDSNAP_URL || '';
export const dashURL: string =process.env.NEXT_PUBLIC_DASH_URL || '';
export const apiURL: string =process.env.NEXT_PUBLIC_API_URL || '';
export const apiUploadPath: string = process.env.NEXT_PUBLIC_API_UPLOAD_PATH || '';
export const apiThemeUploadPath: string = process.env.NEXT_PUBLIC_API_THEME_UPLOAD_PATH || '';
export const apiPlanUploadPath: string = process.env.NEXT_PUBLIC_API_PLAN_UPLOAD_PATH || '';
export const apiMediaUrl: string = process.env.NEXT_PUBLIC_API_MEDIA_URL || '';
export const appWappURL: string = process.env.NEXT_PUBLIC_APP_WHATSAPP_URL || '';
export const appURLSplit: string = process.env.NEXT_PUBLIC_URL_SPLIT || '';
export const appCookieBot: string = process.env.NEXT_PUBLIC_COOKIEBOT_DOMAIN_GROUP || '';
export const appGTM: string = process.env.NEXT_PUBLIC_GTM || '';
export const appReviews: string = process.env.NEXT_PUBLIC_GOOGLE_REVIEWS || '';
export const recaptchaSiteKey: string = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';
export const appAmbassadorPageURL: string = '/ambassador';
export const appContactPageURL: string = '/contact';
export const appSetupPageURL: string = '/setup/?orderId=';
